import { useEffect, useState } from "react";
import { searchBoMForSelect } from "../store/api/ProductionAPI";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileInvoice, faTimes } from "@fortawesome/free-solid-svg-icons";
import { bomTypes } from "../../store/api/CommonFunctions";
import BihamtaTable from "../../Components/BihamtaTable";

export default function ModalSelectBoM(props) {
    const { popData, setPopData } = props;
    const { show, types, onSelect, productID } = popData;
    const [dataList, setDataList] = useState();
    let title = "انتخاب ";
    const titles = [];
    types?.forEach(t => {
        if (Number(t) === bomTypes.BoM) {
            titles.push("فرمول ساخت");
        }
        if (Number(t) === bomTypes.ProductionEstimate) {
            titles.push("برآورد تولید");
        }
        if (Number(t) === bomTypes.ProductionInvoice) {
            titles.push("فاکتور تولید");
        }
    });

    title += titles.join("/");
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "شماره فرم", colName: "Code", showInMobile: true },
        { colTitle: "تاریخ فرم", colName: "PFormDate", showInMobile: true },
        { colTitle: "نوع فرم", colName: "PBillType" },
        { colTitle: "شرح فرم", colName: "Description" }
    ]
    function close() {
        setPopData({
            show: false
        })
    }
    function rowClick(row) {
        if (onSelect) {
            setPopData({ show: false });
            onSelect({ ID: row.ID });
        }
    }
    useEffect(() => {
        if (show) {
            const filterData = { ProductID: productID, BillTypes: types, UnUsed: types.contains(bomTypes.ProductionEstimate), ForSelect: true };
            searchBoMForSelect(filterData, setDataList);
        }
    }, [show])
    return (
        <Modal show={show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faFileInvoice} size="lg" />&nbsp;
                    {title}
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <BihamtaTable dataList={dataList} maxHeight={500} columns={tableCols} rowClick={rowClick} />
            </Modal.Body>
        </Modal>
    )
}